import React, { useEffect, useState } from 'react';
import { buildAdsbMapUrl, fetchLiveAircraftPosition } from '../adsbService';

export default function AircraftLiveStatus({ aircraft }) {
  const [livePosition, setLivePosition] = useState(null);
  const [checked, setChecked] = useState(false);

  const adsbMapUrl = buildAdsbMapUrl(aircraft?.adsb_icao_hex);

  useEffect(() => {
    setLivePosition(null);
    setChecked(false);

    if (!aircraft?.registration || !adsbMapUrl) return;

    let cancelled = false;

    async function checkLiveAircraft() {
      try {
        const position = await fetchLiveAircraftPosition(aircraft.registration);

        if (!cancelled) {
          setLivePosition(position);
          setChecked(true);
        }
      } catch (_err) {
        if (!cancelled) {
          setLivePosition(null);
          setChecked(true);
        }
      }
    }

    checkLiveAircraft();

    const interval = setInterval(checkLiveAircraft, 30000);

    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [aircraft?.registration, adsbMapUrl]);

  if (!adsbMapUrl || !checked || !livePosition) return null;

  return (
    <a
      href={adsbMapUrl}
      target="_blank"
      rel="noopener noreferrer"
      style={styles.liveBox}
      title="Open live ADS-B map"
    >
      <div style={styles.liveLabel}>🟢 LIVE</div>

      <div style={styles.liveMeta}>
        {formatAltitude(livePosition.altitude)} · {formatSpeed(livePosition.groundspeed)}
      </div>
    </a>
  );
}

function formatAltitude(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return 'ALT -';
  return `${Math.round(number).toLocaleString()} ft`;
}

function formatSpeed(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return 'SPD -';
  return `${Math.round(number)} kt`;
}

const styles = {
  liveBox: {
    marginTop: 4,
    padding: '0.2rem 0.38rem',
    borderRadius: 999,
    background: 'rgba(143,244,182,0.12)',
    border: '1px solid rgba(143,244,182,0.28)',
    color: '#8ff4b6',
    textDecoration: 'none',
    display: 'inline-flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 1,
    maxWidth: '100%',
  },

  liveLabel: {
    fontSize: '0.56rem',
    fontWeight: 950,
    letterSpacing: '0.06em',
  },

  liveMeta: {
    color: '#d7ebff',
    fontSize: '0.54rem',
    fontWeight: 800,
    whiteSpace: 'nowrap',
  },
};